import AIEmbedding from 'App/babel/resources/AIEmbedding';
import RequestBuilder from 'Resources/RequestBuilder';
import ComparisonTypes, { type ComparisonTypeName } from 'Resources/ComparisonTypes';

type Filter = {
	value: string;
	comparisonType: ComparisonTypeName;
	inactive: boolean;
	vectorSearchIds?: string[];
};

type RawFilter = {
	v?: string | string[];
	c?: ComparisonTypeName;
	i?: boolean;
};

function generateFilter(countryCode: string) {
	function generate(): Filter {
		return {
			inactive: true,
			comparisonType: 'Equals',
			value: '',
			vectorSearchIds: []
		};
	}

	function isInactive(filter: Filter) {
		const searchText = (filter.value ?? '').trim();
		return !searchText;
	}

	function toUrl(filter: Filter) {
		const rawValue = filter.value ?? '';
		const trimmed = rawValue.trim();
		return {
			v: trimmed,
			i: filter.inactive,
			c: filter.comparisonType
		};
	}

	function fromUrl(rawFilter: RawFilter) {
		const filter = generate();

		if (typeof rawFilter.v === 'string') {
			filter.value = rawFilter.v;
		} else if (Array.isArray(rawFilter.v)) {
			filter.value = rawFilter.v.filter(Boolean).join(' ');
		} else {
			filter.value = '';
		}

		if (rawFilter.c) {
			filter.comparisonType = rawFilter.c;
		}

		filter.inactive = rawFilter.i ?? isInactive(filter);

		return filter;
	}

	function build(filter: Filter, rb: RequestBuilder) {
		const searchText = (filter.value ?? '').trim();
		if (filter.inactive || !searchText) {
			return;
		}

		if (filter.vectorSearchIds && filter.vectorSearchIds.length > 0) {
			rb.addFilter({ field: 'prospectingId' }, ComparisonTypes.Equals, filter.vectorSearchIds);
		} else if (filter.vectorSearchIds && filter.vectorSearchIds.length === 0) {
			rb.addFilter({ field: 'prospectingId' }, ComparisonTypes.Equals, ['-1']);
		}
	}

	async function performVectorSearch(searchValue: string, headquarters: boolean | null): Promise<string[]> {
		const searchText = searchValue.trim();
		if (!searchText) {
			return [];
		}

		const result = await AIEmbedding.matchSummaryCompanies(
			searchText,
			countryCode,
			300,
			0.7,
			false,
			headquarters,
			false
		);

		return result.companies?.map((company: { prospectingId: string }) => company.prospectingId) ?? [];
	}

	function displayText(searchText: string) {
		return searchText.trim();
	}

	return {
		filterName: 'FreeTextSearch',
		field: 'prospectingId',
		type: 'raw',
		comparisonType: 'Equals',
		displayType: 'freeText',
		title: 'default.freeText',
		showOnSegment: true,
		tooltip: 'prospecting.manually.freeTextSearchDescription',
		generate,
		toUrl,
		fromUrl,
		isInactive,
		build,
		performVectorSearch,
		displayText
	};
}

export default generateFilter;
